import { useContext } from 'react'

import { Box, Button, Text } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { BackButton } from '../../components/BackButton/back-button.comp'
import { ConfirmModalContext } from '../../components/ConfirmModal'
import { NewItem } from '../../components/NewItem/new-item.comp'

import { CreateItemTraceabilityTree } from './components/CreateItemTraceabilityTree'
import { ItemHeader } from './components/ItemHeader/item-header.comp'
import { UploadSheet } from './components/UploadSheet/upload-sheet.comp'
import { OriginItemsContext, OriginItemsProvider } from './origin-items.context'

const OriginItemsComp = () => {
  const {
    tab,
    initialNodes,
    initialEdges,
    nodeTypes,
    submitItemError,
    submitError,
    currentNode,
    editMode,
    actions,
    loading,
  } = useContext(OriginItemsContext)
  const handleSubmit = () => {
    actions.handleSubmit()
  }

  const navigate = useNavigate()
  const { confirmModal } = useContext(ConfirmModalContext)

  const handleCancel = async () => {
    if (
      await confirmModal(
        'Deseja cancelar?',
        'Ao cancelar você perderá permanentemente todos os dados que já cadastrou',
      )
    ) {
      navigate(-1)
    }
  }

  const theme = useTheme()

  if (tab === 'edit') {
    return (
      <NewItem
        currentNode={currentNode}
        editMode={editMode}
        error={submitItemError}
        onCancel={() => actions.setTab('initial')}
        onDeleteNode={actions.deleteNode}
        onSubmit={actions.saveNewNodes}
      />
    )
  }

  if (tab === 'sheet') {
    return <UploadSheet />
  }

  return (
    <Box width="100%" height="calc(100vh - 72px)" position="relative">
      <Box
        width="100%"
        height="100%"
        direction="column"
        padding={3}
        overflow="auto"
        gap={2}
      >
        <Box
          width="100%"
          gap={1}
          alignItems="center"
          justifyContent="space-between"
        >
          <Box alignItems="center" gap={2}>
            <BackButton />
            <Text color="grey_3" size="small">
              Atenção: certifique-se de salvar antes de sair, caso contrário
              seus dados serão perdidos.
            </Text>
          </Box>
          <Box gap={2}>
            <Button variant="outlined" onClick={handleCancel}>
              Cancelar
            </Button>
            <Button type="submit" onClick={handleSubmit} loading={loading}>
              Salvar
            </Button>
          </Box>
        </Box>
        {submitError && (
          <Box justifyContent="flex-end" width="100%">
            <Text color="error">{submitError}</Text>
          </Box>
        )}
        <ItemHeader />

        <Box
          width="100%"
          justifyContent="center"
          alignItems="center"
          borderRadius="12px"
          border={{ width: 1, color: 'grey_5' }}
          boxShadow={theme.box_shadow.card}
          flex={1}
        >
          {!!initialNodes?.length && (
            <CreateItemTraceabilityTree
              initialNodes={initialNodes}
              initialEdges={initialEdges}
              nodeTypes={nodeTypes}
              showDirectionSwitch={false}
              showMinimap={false}
              initialDirection="LR"
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export const OriginItems = () => {
  return (
    <OriginItemsProvider>
      <OriginItemsComp />
    </OriginItemsProvider>
  )
}
